import React from 'react'
import { Typography } from '@mui/material'
import { DialogBase } from './DialogBase'
import wdGif from './WorkdayLink.gif'

type GIFProps = {
    srcGIF: string
}

type MessageProps = {
    message: string
}

export const DialogWorkdaySidebar = ({
    shouldOpenDialog,
    onAcknowledge,
}: {
    shouldOpenDialog: boolean
    onAcknowledge: () => void
}) => {
    const header = 'Access Your Workday Course Link'
    const message = 'Click the sidebar to open your official Workday course registration link.'

    const persistDisable = () => {
        window.localStorage['disable-workday-sidebar-dialog'] = 'true'
        onAcknowledge()
    }

    const Content = () => (
        <>
            <GIF srcGIF={wdGif} />
            <Message message={message} />
        </>
    )

    const Message = ({ message }: MessageProps) => (
        <>
            <Typography align="center" variant="h6">
                {header}
            </Typography>
            <Typography align="center" variant="body1" style={{ marginTop: 10 }}>
                {message}
            </Typography>
        </>
    )

    const GIF = ({ srcGIF }: GIFProps) => (
        <img
            style={{
                borderRadius: 10,
                width: '100%',
                marginBottom: '1rem',
            }}
            src={srcGIF}
        />
    )

    return (
        <DialogBase shouldOpenDialog={shouldOpenDialog} persistDisable={persistDisable}>
            <Content />
        </DialogBase>
    )
}